export const DRAG_DROP_COPY = 'Click or drag-and-drop 2 or more image files';
export const LOADING_COPY = 'Generating Instaswipe Video... Please wait up to 5 minutes.';
